<template>
  <div class="b-contact b-contact-box">
    <div class="b-container">
      <div class="b-main">
        <div class="b-left">
          <div class="b-left-name">Contact Us</div>
          <div class="b-contactList">
            <ul>
              <li v-for="item in contactList"
                  :key="item">
                <div class="b-cion">
                  <img :src="item.coin"
                       alt="img" />
                </div>
                <div class="b-name">{{ item.name }}：</div>
                <div class="b-description">{{ item.description }}</div>
              </li>
            </ul>
          </div>
          <div class="copyright">
            <div class="b-name">
              Copyright © Institute of Translational Medicine, SJTU
            </div>
          </div>
        </div>
        <div class="b-center">
          <div class="b-left-name">Links</div>
          <div class="b-link">
            <ul>
              <li v-for="item in linkList"
                :key="item">
                <a :href="item.linkUrl" class="b-link-a" target="_blank">
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="b-right">
          <div class="b-left-name">Follow Us</div>
          <div class="b-right-box">
            <div class="b-right-icon b-icon-1"></div>
            <div class="b-right-message">
              <div class="b-name">WeChat</div>
              <div class="b-text">Institute of Translational Medicine, SJTU<br>Zhuanhuayixue_SJTU</div>
            </div>
            <div class="b-img">
                <img src="../../../assets/img/wechat.jpg" alt="img">
              </div>
          </div>
          <div class="b-right-box">
            <div class="b-right-icon b-icon-2"></div>
            <div class="b-right-message">
              <div class="b-name">Emails</div>
              <div class="b-text">user.tm@sjtu.edu.cn</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data () {
    return {
      contactList: [],
      linkList:[]
    };
  },
  mounted () {
    this.contactList = [
      {
        coin: require("../../../assets/img/icon57.png"),
        name: "Minhang Base",
        description: "800 Dongchuan Road, Minhang District, Shanghai, P.R. China"
      },
      {
        coin: require("../../../assets/img/icon57.png"),
        name: "Ruijin Base",
        description: "197 Ruijin Second Road, Huangpu District, Shanghai, P.R. China"
      },
      // {
      //   coin: require("../../assets/img/icon58.png"),
      //   name: "微信公众号",
      //   description: "123456"
      // }
    ];
    this.linkList = [
      {
        linkUrl: "http://en.sjtu.edu.cn/",
        name:"Shanghai Jiao Tong University"
      },
      {
        linkUrl: "http://iac.sjtu.edu.cn/customer/index/index_en.html",
        name:" Instrumental Analysis Center, SJTU "
      },
      {
        linkUrl: "https://dnastorage.sjtu.edu.cn/",
        name:" Center for DNA Data Storage, SJTU "
      },
      {
        linkUrl: "https://chembio.sjtu.edu.cn/",
        name:" Department of Chemical Biology, SJTU "
      }
    ]
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/base.css";
/*  联系我们样式  */
.b-contact-box{
  background: #10182d;
  padding: 30px 0;
  .b-main{
    display: flex;
  }
  .b-left-name{
    font-size: 18px;
    color: #fff;
    line-height: 34px;
    text-align: left;
    margin-bottom: 15px;
  }
  .b-left{
    width: 42%;
    float: left;
    .b-contactList ul li {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      .b-cion {
        width: 20px;
        height: 20px;
      }
      .b-name,
      .b-description {
        text-align: inherit;
        font-weight: normal;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        line-height: 24px;
        display: inline-block;
        font-size: 13px;
        color: #999;
        padding-left: 5px;
      }
    }
    .copyright{
      margin-top: 15px;
      text-align: left;
      .b-name{
        color: #999;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  .b-center{
    width: 23%;
    float: left;
    .b-link{
      text-align: left;
      li{
        display: inline-block;
        margin-bottom: 12px;
        padding-right: 12px;
        //border-right: 1px solid #999;
        margin-right: 12px;
        .b-link-a{
          color: #999;
          font-size: 14px;
          line-height: 16px;
        }
      }
      li:last-child{
        border-right: none;
      }
    }
  }
  .b-right{
    width: 35%;
    .b-right-box{
      display: flex;
      text-align: left;
      .b-icon-1{
        background: url(../../../assets/img/icon55.png) no-repeat!important;
        background-size: cover!important;
      }
      .b-icon-2{
        background: url(../../../assets/img/icon59.png) no-repeat!important;
        background-size: cover!important;
      }
      .b-right-icon{
        width: 32px;
        height: 32px;
        margin-right: 15px;
      }
      .b-right-message{
        .b-text,
        .b-name{
          font-size: 13px;
          color: #999;
          line-height: 18px;
        }
        .b-name{
          margin-top: 5px;
          margin-bottom: 8px;
        }
      }
      .b-img{
        max-width: 90px;
        margin-left: 30px;
      }
    }

  }
}

/* 导航菜单 */
.b-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .b-title-left {
    display: flex;
    align-items: center;
    .b-coin {
      width: 30px;
      height: 30px;
      background: url(../../../assets/img/coin.png) no-repeat;
      background-size: contain;
    }
    .b-name {
      text-align: inherit;
      font-weight: bold;
      font-family: Avenir, Helvetica, Arial, sans-serif;
      line-height: 2;
      display: inline-block;
      color: rgb(0, 0, 0);
      padding-left: 10px;
      font-size: 26px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/contact/en/index.vue